<template>
  <div class="container-fluid">
    <div class="row pt-4">
     <div class="col">
      <p class="page-title"><i class="fas fa-file-invoice"></i> Order Detail</p>
     </div>
    </div>
    <div class="row">
      <div class="col">
        <b-tabs content-class="mt-3">
          <b-tab title="Marketplace" active v-if="orderData">
            <marketplaces-order-detail
              :data="this.orderData.Marketplace"
              :CA="false"
            />
          </b-tab>
          <b-tab title="CA" v-if="orderData">
            <marketplaces-order-detail
              :data="this.orderData.ChannelAdvisor"
              :CA="true"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BTabs, BTab } from 'bootstrap-vue';
import orderDetail from '../../../components/OrderDetail/OrderDetail.vue';
import OrderApiRequest from '@/components/ApiRequester/Order.js';

export default {
  name: 'home',
  components: {
    BTabs,
    BTab,
    'marketplaces-order-detail': orderDetail,
  },
    data() {
    return {
      orderData: undefined
    }
  },
  computed: {
    // marketplaceClass: function () {
    //   return {
    //     'col-6': this.marketplace !== 'ebay',
    //     'col-4': this.marketplace === 'ebay',
    //   }
    // }
  },
  mounted() {
      this.marketplace = this.$route.params.marketplace;
      document.getElementById('loader').classList.add('active');
      const orderApiRequest = new OrderApiRequest();
      let payload = {
        id: this.$route.params.id,
      };

       orderApiRequest.orderDetail(payload).then((response) => { // llamada <-
          this.orderData = response.data;
          document.getElementById('loader').classList.remove('active');
       }).catch(() => {
         document.getElementById('loader').classList.remove('active');
       });
  },
  methods: {


  }
};
</script>

